import objectPath from "object-path";
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const DropdownMenu = ({ title, items }) => {
  const [open, setOpen] = useState(false);
  const [active, setactive] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      className='relative inline-block  cursor-pointer text-left mx-2'
      ref={menuRef}
    >
      <div onClick={() => setOpen(!open)} className={`mx-2 `}>
        {title}
      </div>

      {open && (
        <div className='absolute left-0 mt-2 w-40 bg-white border border-gray-200 rounded shadow-lg z-100'>
          <ul className='py-1 text-sm text-gray-700'>
            {items?.map((r, index) => {
              const name = objectPath.get(r, "title");
              const _id = objectPath.get(r, "_id");
              return (
                <li
                  onClick={() => {
                    navigate(`/order/type/${_id}`, {
                      state: { name: name },
                    });
                    setactive(true);
                    setOpen(false);
                  }}
                  key={index}
                  className='px-4 py-2 hover:bg-primary hover:text-white cursor-pointer'
                >
                  {name}
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};
export default DropdownMenu;
